import useIsNA from "@dana/Common/Hooks/useIsNA";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, LoadRealTimePrices } from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/LoadProductPricingAndInventory";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(
    chain,
    LoadRealTimePrices,
    async props => {
    if (!props.parameter.product || !props.parameter.productInfosById) {
        return;
    }

    const productIds = Object.keys(props.parameter.productInfosById);
    const productPriceParameters = productIds.map(productId => {
        const productInfo = props.parameter.productInfosById![productId];
        return {
            productId: productInfo!.productId,
            unitOfMeasure: productInfo!.unitOfMeasure,
            qtyOrdered: productInfo!.qtyOrdered,
        };
    });
    const isNARegion = useIsNA(props.getState());
    const product = props.parameter.product;
    const showAddToCart = product?.properties?.showRtbCodeAddToCart;
    const isOEMPart = product?.properties?.isOEMPart;
    const rtbCode = product?.properties?.rtbCode;

    const willShowSalesRepModel =
        isOEMPart === "true" ||
        (!isNARegion && rtbCode === "P09");

    const shouldLoadPricing =
        showAddToCart === "true" && !willShowSalesRepModel;

    if (!shouldLoadPricing) {
        return;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters,
            onComplete: pricingProps => {
                if (pricingProps.apiResult?.realTimePricingResults) {
                    const pricing = pricingProps.apiResult.realTimePricingResults!.find(
                        o => o.productId === props.parameter.product?.id,
                    );
                    if (pricing) {
                        props.dispatch({
                            type: "Pages/ProductDetails/CompleteLoadRealTimePricings",
                            pricings: pricingProps.apiResult.realTimePricingResults,
                        });
                    } else {
                        props.dispatch({
                            type: "Pages/ProductDetails/FailedLoadRealTimePricings",
                            productIds,
                        });
                    }
                } else if (pricingProps.error) {
                    props.dispatch({
                        type: "Pages/ProductDetails/FailedLoadRealTimePricings",
                        productIds,
                    });
                }

                props.pricingLoaded = true;
            },
        }),
    );

    if (getSettingsCollection(props.getState()).productSettings.inventoryIncludedWithPricing) {
        await waitFor(() => !!props.pricingLoaded);
    }

    },
);